import { CLOUD_COST_WARNING, CLOUD_PROVIDERS, cloudConsoleUrl, type CloudInfo, type CloudProvider } from '@couch/shared';
import { Link } from 'react-router';

/** "Cloud · Google Cloud · g2-standard-4 · europe-west4 · spot". */
export function cloudLine(cloud: CloudInfo): string {
  return ['Cloud', CLOUD_PROVIDERS[cloud.provider].label, cloud.instanceType, cloud.region, cloud.spot ? 'spot' : null]
    .filter(Boolean).join(' · ');
}

/** The cost warning (doc 51): Couch tries to stop the machine; the user checks; no liability. */
export function CloudCostWarning() {
  return <p className="cloud-warning" role="note"><strong>Costs:</strong> {CLOUD_COST_WARNING}</p>;
}

/** A link to a provider's console, always in a new tab. */
export function ConsoleLink({ href, provider }: { href: string; provider: CloudProvider }) {
  return (
    <a className="button button-quiet" href={href} target="_blank" rel="noopener noreferrer">
      Open in {CLOUD_PROVIDERS[provider].label} console ↗
    </a>
  );
}

/** What a cloud machine shows on its card and page: what it is, its console, the warning. */
export function CloudBadge({ cloud }: { cloud: CloudInfo }) {
  return (
    <div className="cloud-badge">
      <p className="cloud-line">{cloudLine(cloud)}</p>
      <ConsoleLink href={cloudConsoleUrl(cloud)} provider={cloud.provider} />
      <CloudCostWarning />
    </div>
  );
}

/** "A cloud GPU?" in "Add machine" (Linux): the guide, each provider's console, the warning. */
export function CloudChoices() {
  return (
    <div className="cloud-choices">
      <p>
        A cloud GPU? Create the machine at your provider, then paste the command there — see the <Link to="/knowledge/cloud-gpu">cloud GPU guide</Link>.
      </p>
      <p className="cloud-consoles">
        {(Object.keys(CLOUD_PROVIDERS) as CloudProvider[]).map((p) => <ConsoleLink key={p} href={CLOUD_PROVIDERS[p].console} provider={p} />)}
      </p>
      <CloudCostWarning />
    </div>
  );
}
